import { Component } from 'preact';
import ploneApi from 'api/PloneApi';

import PloneLink from 'components/PloneLink';

export default class AbstractListingView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            children: []
        }
    }

    updateChildren() {
        if(
            (this.props.item.hasOwnProperty("layout") && this.props.item.layout === "listing_view")
            || this.props.item["@type"] === "lkd-document"
        ) {
            // we don't need to fetch the full items
            this.setState({
                children: this.props.item.items
            });
            return;
        }

        ploneApi.getChildren(this.props.item["@id"])
            .then(data => {
                this.setState({
                    children: data.items
                });
            });
    }

    componentDidMount() {
        this.updateChildren();
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.item["@id"] !== prevProps.item["@id"]) {
            this.setState({
                children: []
            });
            this.updateChildren();
        }
    }
}


// WEBPACK FOOTER //
// ./components/ContentViews/AbstractListingView.jsx